import React from 'react'

const Pytm3 = () => {
    return (
        <div  className='container'>
        <h1>Reverse a linked list</h1>
        <p>Given pointer to the head node of a linked list, the task is to reverse the linked list. We need to reverse the list by changing the links between nodes.</p>
        <p><strong>Examples</strong>:&nbsp;</p>
        <blockquote className='containers'> <p><strong>Input</strong>: Head of following linked list&nbsp;<br/>
        1-&gt;2-&gt;3-&gt;4-&gt;NULL&nbsp;<br/>
        <strong>Output</strong>: Linked list should be changed to,&nbsp;<br/>
        4-&gt;3-&gt;2-&gt;1-&gt;NULL</p><p><strong>Input</strong>: Head of following linked list&nbsp;<br/>
        1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;NULL&nbsp;<br/>
        <strong>Output</strong>: Linked list should be changed to,&nbsp;<br/>
        5-&gt;4-&gt;3-&gt;2-&gt;1-&gt;NULL</p><p><strong>Input</strong>: NULL&nbsp;<br/>
        <strong>Output</strong>: NULL</p><br/>
       <p><strong>Input</strong>: 1-&gt;NULL&nbsp;<br/>
        <strong>Output</strong>: 1-&gt;NULL&nbsp;<br/>
        &nbsp;</p></blockquote>
        <p><strong>Iterative Method</strong>&nbsp;</p>
        <blockquote className='containers'><ol><li>Initialize three pointers prev as NULL, curr as head and next as NULL.</li><li>Iterate through the linked list. In loop, do following.&nbsp;<br/>
        // Before changing next of current,&nbsp;<br/>
        // store next node&nbsp;<br/>
        next = curr-&gt;next<br/>
        // Now change next of current&nbsp;<br/>
        // This is where actual reversing happens&nbsp;<br/>
        curr-&gt;next = prev&nbsp;<br/>
        // Move prev and curr one step forward&nbsp;<br/>
        prev = curr&nbsp;<br/>
        curr = next</li></ol></blockquote>

               <div class="tabs">
<input type="radio" name="tab" id="tab1"/>
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>

<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Iterative C++ program to reverse</code></div>
<div class="line number2 index1 alt1"><code class="comments">// a linked list</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;iostream&gt;</code></div>
<div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="comments">/* Link list node */</code></div>
<div class="line number7 index6 alt2"><code class="keyword bold">struct</code> <code class="plain">Node &#123;</code>
</div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next;</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node(</code><code class="color1 bold">int</code> <code class="plain">data)</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">this</code><code class="plain">-&gt;data = data;</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = NULL;</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number15 index14 alt2"><code class="plain">&#125;;</code></div>
<div class="line number16 index15 alt1">&nbsp;</div>
<div class="line number17 index16 alt2"><code class="keyword bold">struct</code> <code
        class="plain">LinkedList &#123;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* head;</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">LinkedList() &#123; head = NULL; &#125;</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Function to reverse the linked list */</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">void</code> <code class="plain">reverse()</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Initialize current, previous and</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// next pointers</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* current = head;</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node *prev = NULL, *next = NULL;</code></div>
<div class="line number28 index27 alt1">&nbsp;</div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(current != NULL) &#123;</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Store next</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = current-&gt;next;</code></div>
<div class="line number32 index31 alt1">&nbsp;</div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Reverse current node's pointer</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current-&gt;next = prev;</code></div>
<div class="line number35 index34 alt2">&nbsp;</div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Move pointers one position ahead.</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev = current;</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current = next;</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head = prev;</code></div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Function to print linked list */</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">void</code> <code class="plain">print()</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* temp = head;</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(temp != NULL) &#123;</code></div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; temp-&gt;data &lt;&lt; </code><code class="string">" "</code><code
        class="plain">;</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp = temp-&gt;next;</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number52 index51 alt1">&nbsp;</div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">void</code> <code class="plain">push(</code><code class="color1 bold">int</code> <code
        class="plain">data)</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node* temp = </code><code class="keyword bold">new</code> <code
        class="plain">Node(data);</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp-&gt;next = head;</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head = temp;</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number59 index58 alt2"><code class="plain">&#125;;</code></div>
<div class="line number60 index59 alt1">&nbsp;</div>
<div class="line number61 index60 alt2"><code class="comments">/* Driver code*/</code></div>
<div class="line number62 index61 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number63 index62 alt2"><code class="plain">&#123;</code></div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Start with the empty list */</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">LinkedList ll;</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.push(20);</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.push(4);</code></div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.push(15);</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.push(85);</code></div>
<div class="line number70 index69 alt1">&nbsp;</div>
<div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"Given linked list\n"</code><code
        class="plain">;</code></div>
<div class="line number72 index71 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.print();</code></div>
<div class="line number73 index72 alt2">&nbsp;</div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.reverse();</code></div>
<div class="line number75 index74 alt2">&nbsp;</div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"\nReversed Linked list \n"</code><code
        class="plain">;</code></div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ll.print();</code></div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number79 index78 alt2"><code class="plain">&#125;</code></div>
</div>
  </div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Java program for reversing the linked list</code>
</div>
<div class="line number2 index1 alt1">&nbsp;</div>
<div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">LinkedList &#123;</code>
</div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="plain">Node head;</code></div>
<div class="line number6 index5 alt1">&nbsp;</div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">class</code> <code class="plain">Node &#123;</code></div>
<div class="line number8 index7 alt1">&nbsp;</div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">data;</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node next;</code></div>
<div class="line number11 index10 alt2">&nbsp;</div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node(</code><code class="keyword">int</code> <code class="plain">d)</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">data = d;</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number18 index17 alt1">&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Function to reverse the linked list */</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node reverse(Node node)</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node prev = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node current = node;</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node next = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(current != </code><code class="keyword">null</code><code
        class="plain">) &#123;</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = current.next;</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current.next = prev;</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev = current;</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current = next;</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node = prev;</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">node;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number34 index33 alt1">&nbsp;</div>
<div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// prints content of double linked list</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">void</code> <code class="plain">printList(Node node)</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(node != </code><code class="keyword">null</code><code
        class="plain">) &#123;</code></div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(node.data + </code><code class="string">" "</code><code
        class="plain">);</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">node = node.next;</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number43 index42 alt2">&nbsp;</div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Driver Code</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String[] args)</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">LinkedList list = </code><code class="keyword">new</code> <code
        class="plain">LinkedList();</code></div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">list.head = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">85</code><code class="plain">);</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">list.head.next = </code><code class="keyword">new</code> <code class="plain">Node(</code><code
        class="value">15</code><code class="plain">);</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">list.head.next.next = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">4</code><code class="plain">);</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">list.head.next.next.next = </code><code class="keyword">new</code> <code
        class="plain">Node(</code><code class="value">20</code><code class="plain">);</code></div>
<div class="line number52 index51 alt1">&nbsp;</div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"Given Linked list"</code><code
        class="plain">);</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">list.printList(head);</code></div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head = list.reverse(head);</code></div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">""</code><code class="plain">);</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code><code class="string">"Reversed linked list "</code><code
        class="plain">);</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">list.printList(head);</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number60 index59 alt1"><code class="plain">&#125;</code></div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code
        class="comments">// This code has been contributed by Mayank Jaiswal</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python program to reverse a linked list</code></div>
<div class="line number2 index1 alt1"><code class="comments"># Time Complexity : O(n)</code></div>
<div class="line number3 index2 alt2"><code class="comments"># Space Complexity : O(1)</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="comments"># Node class</code></div>
<div class="line number6 index5 alt1">&nbsp;</div>
<div class="line number7 index6 alt2">&nbsp;</div>
<div class="line number8 index7 alt1"><code class="keyword">class</code> <code class="plain">Node:</code></div>
<div class="line number9 index8 alt2">&nbsp;</div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Constructor to initialize the node object</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">, data):</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.data </code><code class="keyword">=</code> <code
        class="plain">data</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.</code><code class="functions">next</code> <code
        class="keyword">=</code> <code class="color1">None</code></div>
<div class="line number14 index13 alt1">&nbsp;</div>
<div class="line number15 index14 alt2">&nbsp;</div>
<div class="line number16 index15 alt1"><code class="keyword">class</code> <code class="plain">LinkedList:</code>
</div>
<div class="line number17 index16 alt2">&nbsp;</div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Function to initialize head</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.head </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Function to reverse the linked list</code></div>
<div class="line number23 index22 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">reverse(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev </code><code class="keyword">=</code> <code class="color1">None</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.head</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code><code class="plain">(current </code><code class="keyword">is</code> <code
        class="keyword">not</code> <code class="color1">None</code><code class="plain">):</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">next</code> <code class="keyword">=</code> <code class="plain">current.</code><code
        class="functions">next</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current.</code><code class="functions">next</code> <code class="keyword">=</code> <code
        class="plain">prev</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev </code><code class="keyword">=</code> <code class="plain">current</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current </code><code class="keyword">=</code> <code class="functions">next</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.head </code><code class="keyword">=</code> <code
        class="plain">prev</code></div>
<div class="line number32 index31 alt1">&nbsp;</div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Function to insert a new node at the beginning</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">push(</code><code class="color1">self</code><code
        class="plain">, new_data):</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node </code><code class="keyword">=</code> <code class="plain">Node(new_data)</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node.</code><code class="functions">next</code> <code class="keyword">=</code> <code
        class="color1">self</code><code class="plain">.head</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.head </code><code class="keyword">=</code> <code
        class="plain">new_node</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Utility function to print the linked LinkedList</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">printList(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.head</code></div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code><code class="plain">(temp):</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code> <code class="plain">temp.data,</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keyword">=</code> <code class="plain">temp.</code><code
        class="functions">next</code></div>
<div class="line number45 index44 alt2">&nbsp;</div>
<div class="line number46 index45 alt1">&nbsp;</div>
<div class="line number47 index46 alt2"><code class="comments"># Driver code</code></div>
<div class="line number48 index47 alt1"><code class="plain">llist </code><code class="keyword">=</code> <code
        class="plain">LinkedList()</code></div>
<div class="line number49 index48 alt2"><code class="plain">llist.push(</code><code class="value">20</code><code
        class="plain">)</code></div>
<div class="line number50 index49 alt1"><code class="plain">llist.push(</code><code class="value">4</code><code
        class="plain">)</code></div>
<div class="line number51 index50 alt2"><code class="plain">llist.push(</code><code class="value">15</code><code
        class="plain">)</code></div>
<div class="line number52 index51 alt1"><code class="plain">llist.push(</code><code class="value">85</code><code
        class="plain">)</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code class="functions">print</code> <code
        class="string">"Given Linked List"</code></div>
<div class="line number55 index54 alt2"><code class="plain">llist.printList()</code></div>
<div class="line number56 index55 alt1"><code class="plain">llist.reverse()</code></div>
<div class="line number57 index56 alt2"><code class="keyword">print</code> <code
        class="string">"\nReversed Linked List"</code></div>
<div class="line number58 index57 alt1"><code class="plain">llist.printList()</code></div>
<div class="line number59 index58 alt2">&nbsp;</div>
<div class="line number60 index59 alt1"><code
        class="comments"># This code is contributed by Nikhil Kumar Singh(nickzuck_007)</code></div>
</div>
    </div>
 
   
  <div id="tab-content-4" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Iterative C program to reverse a linked list</code>
</div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;stdlib.h&gt;</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="comments">/* Link list node */</code></div>
<div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">Node &#123;</code>
</div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next;</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#125;;</code></div>
<div class="line number10 index9 alt1">&nbsp;</div>
<div class="line number11 index10 alt2"><code class="comments">/* Function to reverse the linked list */</code>
</div>
<div class="line number12 index11 alt1"><code class="keyword bold">static</code> <code
        class="keyword bold">void</code> <code class="plain">reverse(</code><code class="keyword bold">struct</code>
    <code class="plain">Node** head_ref)</code></div>
<div class="line number13 index12 alt2"><code class="plain">&#123;</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* prev = NULL;</code></div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* current = *head_ref;</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* next = NULL;</code></div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(current != NULL) &#123;</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Store next</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">next = current-&gt;next;</code></div>
<div class="line number20 index19 alt1">&nbsp;</div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Reverse current node's pointer</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current-&gt;next = prev;</code></div>
<div class="line number23 index22 alt2">&nbsp;</div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Move pointers one position ahead.</code></div>
<div class="line number25 index24 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">prev = current;</code></div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">current = next;</code></div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">*head_ref = prev;</code></div>
<div class="line number29 index28 alt2"><code class="plain">&#125;</code></div>
<div class="line number30 index29 alt1">&nbsp;</div>
<div class="line number31 index30 alt2"><code class="comments">/* Function to push a node */</code></div>
<div class="line number32 index31 alt1"><code class="keyword bold">void</code> <code class="plain">push(</code><code
        class="keyword bold">struct</code> <code class="plain">Node** head_ref, </code><code
        class="color1 bold">int</code> <code class="plain">new_data)</code></div>
<div class="line number33 index32 alt2"><code class="plain">&#123;</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* new_node</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">= (</code><code class="keyword bold">struct</code> <code class="plain">Node*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code><code
        class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
        class="plain">Node));</code></div>
<div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;data = new_data;</code></div>
<div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node-&gt;next = (*head_ref);</code></div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*head_ref) = new_node;</code></div>
<div class="line number39 index38 alt2"><code class="plain">&#125;</code></div>
<div class="line number40 index39 alt1">&nbsp;</div>
<div class="line number41 index40 alt2"><code class="comments">/* Function to print linked list */</code></div>
<div class="line number42 index41 alt1"><code class="keyword bold">void</code> <code
        class="plain">printList(</code><code class="keyword bold">struct</code> <code
        class="plain">Node* head)</code></div>
<div class="line number43 index42 alt2"><code class="plain">&#123;</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* temp = head;</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(temp != NULL) &#123;</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d&nbsp; "</code><code
        class="plain">, temp-&gt;data);</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp = temp-&gt;next;</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number49 index48 alt2"><code class="plain">&#125;</code></div>
<div class="line number50 index49 alt1">&nbsp;</div>
<div class="line number51 index50 alt2"><code class="comments">/* Driver code*/</code></div>
<div class="line number52 index51 alt1"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
<div class="line number53 index52 alt2"><code class="plain">&#123;</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Start with the empty list */</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">Node* head = NULL;</code></div>
<div class="line number56 index55 alt1">&nbsp;</div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 20);</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 4);</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 15);</code></div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;head, 85);</code></div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"Given linked list\n"</code><code class="plain">);</code></div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(head);</code></div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">reverse(&amp;head);</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"\nReversed Linked list \n"</code><code class="plain">);</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printList(head);</code></div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">getchar</code><code class="plain">();</code></div>
<div class="line number68 index67 alt1"><code class="plain">&#125;</code></div>
</div>
    </div>
    </div>
</div>
    </div>
    )
}

export default Pytm3
